/**
 * Copyright (c) 2018-2019 Aleksey Melnikov, True Directive Company.
 * @link https://truedirective.com/
 * @license MIT
*/
import { Component, Output, ViewChild, ElementRef, ChangeDetectorRef,
         KeyValueDiffers, EventEmitter, Inject
       } from '@angular/core';

import { takeUntil } from 'rxjs/operators';

import { Column, ColumnBand, CellPosition, GridPart, Selection,
         UIActionType, UIAction, Keys, RowPosition,
         RowLayout } from '@true-directive/base';

import { RowDragEvent, RowClickEvent, ContextMenuEvent, CheckedChangedEvent,
         CellClickEvent } from '@true-directive/base';

import { GridViewComponent } from './grid-view.component';
import { RowDirective } from './row.directive';
import { GridStateService } from './grid-state.service';
import { InternationalizationService } from './internationalization/internationalization.service';


@Component({
  selector: 'true-grid',
  templateUrl: './grid.component.html',
  providers: [{ provide: 'gridState', useClass: GridStateService }],
  styleUrls: [
              // Ð­ÑÐ¸ ÑÑÐ¸Ð»Ð¸ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÑÑÑ ÑÐ°Ð·Ð¼ÐµÑÐºÑ Ð¸ Ð¿Ð¾Ð²ÐµÐ´ÐµÐ½Ð¸Ðµ ÐºÐ¾Ð¼Ð¿Ð¾Ð½ÐµÐ½ÑÐ°.
              './styles/grid.behavior.scss'
             ]
})
export class GridComponent extends GridViewComponent {

  @Output('rowMouseDown')
  rowMouseDown: EventEmitter<any> = new EventEmitter<any>();

  @Output('rowMouseUp')
  rowMouseUp: EventEmitter<any> = new EventEmitter<any>();

  @Output('rowClick')
  rowClick: EventEmitter<RowClickEvent> = new EventEmitter<RowClickEvent>();

  @Output('cellClick')
  cellClick: EventEmitter<CellClickEvent> = new EventEmitter<CellClickEvent>();

  @Output('rowDblClick')
  rowDblClick: EventEmitter<RowClickEvent> = new EventEmitter<RowClickEvent>();

  @Output('rowKeyDown')
  rowKeyDown: EventEmitter<any> = new EventEmitter<any>();

  @Output('contextMenu')
  contextMenu: EventEmitter<ContextMenuEvent> = new EventEmitter<ContextMenuEvent>();

  @Output('selectionChanged')
  selectionChanged: EventEmitter<Selection> = new EventEmitter<Selection>();

  @Output('checkedChanged')
  checkedChanged: EventEmitter<CheckedChangedEvent> = new EventEmitter<CheckedChangedEvent>();

  /**
   * ÐÐ¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ Ð¿ÐµÑÐµÑÐ°ÑÐ¸Ð» ÑÑÑÐ¾ÐºÐ¸. Ð¡Ð¾Ð±ÑÑÐ¸Ðµ Ð²Ð¾Ð·Ð½Ð¸ÐºÐ°ÐµÑ Ð´Ð¾ ÑÐ¾Ð³Ð¾, ÐºÐ°Ðº ÑÑÑÐ¾ÐºÐ¸ Ð±ÑÐ´ÑÑ Ð¿ÐµÑÐµÐ½ÐµÑÐµÐ½Ñ
   * Ð³ÑÐ¸Ð´Ð¾Ð¼. Ð­ÑÐ¾ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ðµ Ð¼Ð¾Ð¶Ð½Ð¾ Ð¾ÑÐ¼ÐµÐ½Ð¸ÑÑ Ð¸ Ð¾Ð±ÑÐ°Ð±Ð¾ÑÐ°ÑÑ Ð²Ð½Ðµ Ð³ÑÐ¸Ð´Ð°.
   */
  @Output()
  rowDrag: EventEmitter<RowDragEvent> = new EventEmitter<RowDragEvent>(false);

  /**
   * ÐÐ¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ Ð¿ÐµÑÐµÑÐ°ÑÐ¸Ð» ÑÑÑÐ¾ÐºÐ¸ Ð¸ Ð³ÑÐ¸Ð´ Ð¾Ð±ÑÐ°Ð±Ð¾ÑÐ°Ð» ÑÑÐ¾ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ðµ.
   */
  @Output()
  rowDragged: EventEmitter<RowDragEvent> = new EventEmitter<RowDragEvent>(false);

  /**
   * ÐÐ°ÑÐºÐµÑ, ÑÐºÐ°Ð·ÑÐ²Ð°ÑÑÐ¸Ð¹ Ð½Ð¾Ð²ÑÑ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ñ Ð¿ÐµÑÐµÑÐ°ÑÐºÐ¸Ð²Ð°ÐµÐ¼Ð¾Ð³Ð¾ ÑÑÐ¾Ð»Ð±ÑÐ°
   */
  @ViewChild('dropMarker', {static: true})
  dropMarker: any;

  private _cellTouched: CellPosition = null; // Ð¯ÑÐµÐ¹ÐºÐ° Ñ ÑÐ°ÑÐµÐ¼
  private _cellTouchedScrollPos: { X: number, Y: number } = { X: 0, Y: 0 };

  private _dragColumn = false; // ÐÐµÑÐµÑÐ°ÑÐºÐ¸Ð²Ð°Ð½Ð¸Ðµ Ð·Ð°Ð³Ð¾Ð»Ð¾Ð²ÐºÐ° ÐºÐ¾Ð»Ð¾Ð½ÐºÐ¸ Ð² Ð¿ÑÐ¾ÑÐµÑÑÐµ

  private _drag_x0 = -1; // ÐÑÐµÐ´ÑÐ´ÑÑÐ°Ñ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ñ Ð¿ÐµÑÐµÑÐ°ÑÐºÐ¸Ð²Ð°ÐµÐ¼Ð¾Ð³Ð¾ Ð·Ð°Ð³Ð¾Ð»Ð¾Ð²ÐºÐ°
  private _drag_y0 = -1;
  private _lastSel = 0; // ÐÑÐµÐ¼Ñ Ð¿Ð¾ÑÐ»ÐµÐ´Ð½ÐµÐ³Ð¾ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ Ð²ÑÐ´ÐµÐ»ÐµÐ½Ð¸Ñ
  private _paging = false; // ÐÑÐ¸Ð´ Ð² Ð¿ÑÐ¾ÑÐµÑÑÐµ Ð¸ÑÐ¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ PgDn/PgUp

  public get isDragging() {
    return this._dragColumn;
  }

  /**
   * ÐÐ°ÑÐ°Ð»Ð¾ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ (Ð¿ÐµÑÐµÐ¼ÐµÑÐµÐ½Ð¸Ðµ ÑÑÑÐ¾ÐºÐ¸ Ð¸Ð»Ð¸ Ð²ÑÐ´ÐµÐ»ÐµÐ½Ð¸Ðµ ÑÑÐµÐµÐº)
   * @param  eX      ÐÐ°ÑÐ°Ð»ÑÐ½Ð°Ñ ÐºÐ¾Ð¾ÑÐ´Ð¸Ð½Ð°ÑÐ° X
   * @param  eY      ÐÐ°ÑÐ°Ð»ÑÐ½Ð°Ñ ÐºÐ¾Ð¾ÑÐ´Ð¸Ð½Ð°ÑÐ° Y
   * @param  place   Ð§Ð°ÑÑÑ Ð³ÑÐ¸Ð´Ð°, Ð² ÐºÐ¾ÑÐ¾ÑÐ¾Ð¹ Ð¸Ð½Ð¸ÑÐ¸Ð¸ÑÐ¾Ð²Ð°Ð½Ð¾ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ðµ
   * @param  ctrlKey ÐÐ°Ð¶Ð°ÑÐ° Ð»Ð¸ ÐºÐ»Ð°Ð²Ð¸ÑÐ° Ctrl
   * @param  byTouch ÐÐ½Ð¸ÑÐ¸Ð¸ÑÐ¾Ð²Ð°Ð½Ð¾ Ð»Ð¸ ÑÐ°Ñ-ÑÐ¾Ð±ÑÑÐ¸ÐµÐ¼
   */
  protected startAction(cp: CellPosition, eX: number, eY: number, place: GridPart,
    ctrlKey: boolean = false, byTouch: boolean = false, button: number = 0) {
    if (cp && cp.row) {
      this.scroller.prepareAutoScroll();
      const uiType = this.state.ui.startAction(cp, ctrlKey, byTouch, button);
      if (uiType) {
        this.uiAction = new UIAction(uiType, null, eX, eY);
        this.addDocumentMouseListeners();
      }
    }
  }

  /**
   * ÐÐ°ÑÐ°Ð½Ð¸Ðµ Ð¿Ð°Ð»ÑÑÐµÐ¼
   * @param  e ÐÐ°ÑÐ°Ð¼ÐµÑÑÑ ÑÐ¾Ð±ÑÑÐ¸Ñ
   */
  public touchStart(e: any) {

    // Ð ÑÐµÑÐµÐ½Ð¸Ðµ 50Ð¼Ñ Ð½Ðµ Ð²ÑÐ´ÐµÐ»ÑÐµÐ¼ Ð¿Ð¾ ÑÐ°ÑÑÑÐ°ÑÑÑ, Ð¿Ð¾ÑÐ¾Ð¼Ñ ÑÑÐ¾ ÑÑÐ¾Ñ ÑÐ°Ñ Ð¾ÑÑÐ°Ð½Ð°Ð²Ð»Ð¸Ð²Ð°ÐµÑ
    // Ð¿ÑÐ¾ÐºÑÑÑÐºÑ
    if (this._lastScroll.time > 0) {
      const ms = Date.now() - this._lastScroll.time;
      if (ms < 50) {
        // ÐÐµ Ð²ÑÐ´ÐµÐ»ÑÐµÐ¼ Ð½Ð¸ÑÐµÐ³Ð¾, ÐµÑÐ»Ð¸ Ð¼Ñ Ð¾ÑÑÐ°Ð½Ð¾Ð²Ð¸Ð»Ð¸ Ð¿ÑÐ¾ÐºÑÑÑÐºÑ
        return;
      }
    }

    e.stopPropagation();

    const touches = e.changedTouches;
    if (touches.length === 1) {
      // ÐÑÐ»Ð¸ ÐºÐ°ÑÐ°Ð½Ð¸Ðµ Ð¾Ð´Ð½Ð¾, ÑÐ¾ Ð·Ð°Ð¿Ð¾Ð¼Ð¸Ð½Ð°ÐµÐ¼ ÑÑÐµÐ¹ÐºÑ, ÐºÐ¾ÑÐ¾ÑÐ¾Ð¹ ÐºÐ°ÑÐ°ÐµÐ¼ÑÑ
      this._cellTouched = this.cellByXY(touches[0].clientX, touches[0].clientY);
      // ÐÐ°Ð¿Ð¾Ð¼Ð¸Ð½Ð°ÐµÐ¼ Ð¿Ð¾Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ Ð¿ÑÐ¾ÐºÑÑÑÐºÐ¸
      this._cellTouchedScrollPos = {
        X: this.scroller.scrollLeft,
        Y: this.scroller.scrollTop
      };
    }
  }

  // ÐÑÐ¾Ð²ÐµÑÐ¸Ð¼, Ð½Ðµ Ð±ÑÐ»Ð¾ Ð»Ð¸ ÑÐºÑÐ¾Ð»Ð»Ð° Ð²Ð¾ Ð²ÑÐµÐ¼Ñ ÐºÐ°ÑÐ°Ð½Ð¸Ñ
  protected get touchScroll() {
    return this._cellTouchedScrollPos.X !== this.scroller.scrollLeft ||
    this._cellTouchedScrollPos.Y !== this.scroller.scrollTop
  }

  /**
   * ÐÐºÐ¾Ð½ÑÐ°Ð½Ð¸Ðµ ÐºÐ°ÑÐ°Ð½Ð¸Ñ
   * @param  e ÐÐ°ÑÐ°Ð¼ÐµÑÑÑ ÑÐ¾Ð±ÑÑÐ¸Ñ
   */
  public touchEnd(e: any) {

    const touches = e.changedTouches;
    if (touches.length >= 1) {
      let rr = this.cellByXY(touches[0].clientX, touches[0].clientY);
      if (rr !== null &&
          rr.equals(this._cellTouched) && !this.touchScroll
        ) {
        // Should we toggle a checkbox in this cell?
        if (this.state.settings.checkByCellClick && this.state.check.canToggleCheck(rr)) {
          // Yes, we should.
          this.state.ui.toggleCheck(rr.row, rr.fieldName);
        } else {
          // Something will be selected.
          if (!rr.equals(this.state.selection.focusedCell)) {
            // ÐÑÐ»Ð¸ ÐºÐ»Ð¸Ðº Ð½Ðµ Ð½Ð° Ð²ÑÐ´ÐµÐ»ÐµÐ½Ð½Ð¾Ð¹ ÑÑÐµÐ¹ÐºÐµ, ÑÐ¾ Ð½Ð°ÑÐ¸Ð½Ð°ÐµÐ¼ Ð²ÑÐ´ÐµÐ»ÐµÐ½Ð¸Ðµ.
            // ÐÐ°ÑÐ°Ð»Ð¾ Ð¸ Ð¾ÐºÐ¾Ð½ÑÐ°Ð½Ð¸Ðµ Ð²ÑÐ´ÐµÐ»ÐµÐ½Ð¸Ñ Ð²ÑÐ½ÐµÑÐµÐ½Ð¾ ÑÑÐ´Ð°, Ñ.Ðº. Ð¼Ñ Ð½Ðµ Ð¼Ð¾Ð¶ÐµÐ¼
            // ÑÑÐ°Ð·Ñ Ð¿Ð¾Ð½ÑÑÑ, Ð´ÐµÐ¹ÑÑÐ²Ð¸Ðµ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ - ÑÑÐ¾ Ð¿ÑÐ¾ÐºÑÑÑÐºÐ° Ð¸Ð»Ð¸
            // Ð²ÑÐ´ÐµÐ»ÐµÐ½Ð¸Ðµ ÑÑÑÐ¾ÐºÐ¸.
            // ÐÐ¾ÑÑÐ¾Ð¼Ñ, ÐµÑÐ»Ð¸ Ð¿Ð¾Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ Ð¿ÑÐ¾ÐºÑÑÑÐºÐ¸ Ð½Ðµ Ð¸Ð·Ð¼ÐµÐ½Ð¸Ð»Ð¾ÑÑ - Ð²ÑÐ´ÐµÐ»ÑÐµÐ¼
            this.startAction(rr, touches[0].clientX, touches[0].clientY, GridPart.CENTER, false, true);
          } else {
            // Ð ÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ Ð¸ ÑÐ¾ÐºÑÑ Ð½Ð° ÑÐµÐ´Ð°ÐºÑÐ¾ÑÐµ
            this.state.ui.startAction(this._cellTouched, false, true);
            e.stopPropagation();
            return;
          }
        }
        // End selecting anyway
        this.state.ui.endSelect(rr, true);
      }
    }
    e.stopPropagation();
  }

  /**
   * ÐÐ°Ð¶Ð°ÑÐ¸Ðµ ÐºÐ½Ð¾Ð¿ÐºÐ¸ Ð¼ÑÑÐ¸.
   * @param  e ÐÐ°ÑÐ°Ð¼ÐµÑÑÑ ÑÐ¾Ð±ÑÑÐ¸Ñ
   */
  public dataMouseDown(e: any) {

    if (this._cellTouched) {
      // Touchstart has been handled. Skip this mousedown.
      return;
    }

    this.rowMouseDown.emit(e);

    if (!e.defaultPrevented) {
      const cp: CellPosition = this.cellByXY(e.clientX, e.clientY);
      if (this.state.ui.mouseDown(cp, false, e.button)) {
        // This event has been handled.
        return;
      }
      this.startAction(cp, e.clientX, e.clientY, GridPart.CENTER, e.ctrlKey, false, e.button);
    }
  }

  protected doRowClick(e: any) {
    if (this.state.ui.click(this.cellByXY(e.clientX, e.clientY))) {
      e.stopPropagation();
      e.preventDefault();
    }
  }

  public dataContextMenu(e: any) {
    if (this.settings.enableDataContextMenu && this.settings.dataContextMenuActions.length > 0) {
      this.menuStarter.start(e, this.state.settings.dataContextMenuActions, 'selection');
      this.detectChanges();
      e.preventDefault();
      return;
    }

    this.contextMenu.emit(
      new ContextMenuEvent(this.cellByXY(e.clientX, e.clientY), e)
    );
  }

  public dataRowClick(e: any, r: any) {
    this.rowClick.emit(new RowClickEvent(r, e));
    this.cellClick.emit(new CellClickEvent(this.cellByXY(e.clientX, e.clientY), e));
    if (this._cellTouched) {
      // Skip this click.
      this._cellTouched = null;
      return;
    }
    this.doRowClick(e);
  }

  public dataRowDblClick(e: any, r: any) {
    this.rowDblClick.emit(new RowClickEvent(r, e));
    this.state.ui.dblClick(e, r);
  }

  /**
   * Key event handler
   * @param  keyEvent Key event parameters
   */
  public processKey(e: any) {

    this.rowKeyDown.emit(e);

    if (e.defaultPrevented) {
      return;
    }

    const keyCode: number = e.keyCode;

    if (keyCode === Keys.SPACE && this.state.selection.focusedRow) {
      let f = this.state.check.firstCheckableField();
      if (f !== '') {
        this.toggleCheckbox({ row: this.state.selection.focusedRow, fieldName: f });
        return true;
      }
    }

    let ri = this.state.dataSource.resultRows.indexOf(this.state.selection.focusedRow);

    if (!this.state.st.fixedRowHeight && (keyCode === Keys.PAGE_DOWN || keyCode === Keys.PAGE_UP)) {
      // ÐÑÐ¸ Ð¿ÐµÑÐµÐ¼ÐµÐ½Ð½Ð¾Ð¹ Ð²ÑÑÐ¾ÑÐµ ÑÑÑÐ¾Ðº Ð¿ÑÐ¾ÐºÑÑÑÐ¸ÑÑ Ð½Ð° Ð¾Ð´Ð½Ñ ÑÑÑÐ°Ð½Ð¸ÑÑ Ð²Ð½Ð¸Ð· Ð¸Ð»Ð¸ Ð²Ð²ÐµÑÑ - Ð±Ð¾Ð»ÑÑÐ°Ñ Ð¿ÐµÑÐ°Ð»Ñ.
      // ÐÐ¾ÑÐ¾Ð¼Ñ ÑÑÐ¾ Ð¼Ñ Ð½Ðµ Ð·Ð½Ð°ÐµÐ¼, ÐºÐ°ÐºÐ°Ñ Ð²ÑÑÐ¾ÑÐ° Ñ ÑÑÑÐ¾Ðº Ð²ÑÑÐµ Ð¸Ð»Ð¸ Ð½Ð¸Ð¶Ðµ ÑÐµÐºÑÑÐµÐ¹ ÑÑÑÐ°Ð½Ð¸ÑÑ.
      // ÐÐ¾ÑÑÐ¾Ð¼Ñ Ð¿ÑÐ¸Ð½Ð¸Ð¼Ð°ÐµÐ¼ ÑÑÐ¶ÐµÐ»Ð¾Ðµ ÑÐµÑÐµÐ½Ð¸Ðµ Ð¸...
      // 1. ÐÐ³Ð½Ð¾ÑÐ¸ÑÑÐµÐ¼ Ð½Ð°Ð¶Ð°ÑÐ¸Ðµ, ÐµÑÐ»Ð¸ ÐµÑÐµ Ð½Ðµ Ð¾Ð±ÑÐ°Ð±Ð¾ÑÐ°Ð»Ð¸ Ð¿ÑÐµÐ´ÑÐ´ÑÑÐµÐµ:
      if (this._paging) {
        return true;
      }

      // 2. Ð ÐµÐ½Ð´ÐµÑÐ¸Ð¼ Ñ Ð·Ð°Ð¿Ð°ÑÐ¾Ð¼
      const overWork = { fwd: 4, back: 4 };

      // 3. ÐÐ°Ð¿Ð°Ñ ÐºÐ°Ðº ÑÐ°Ð· ÑÐ°Ð²ÐµÐ½ Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½Ð¾Ð¼Ñ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ñ ÑÑÑÐ¾Ðº, ÑÐ¼ÐµÑÐ°ÑÑÐµÐ¼ÑÑÑ Ð½Ð° ÑÐºÑÐ°Ð½Ðµ
      if (keyCode === Keys.PAGE_DOWN) {
        overWork.fwd = this.scroller.viewPortHeight / this.RC.currentRH + 1;
      } else {
        if (keyCode === Keys.PAGE_UP) {
          overWork.back = this.scroller.viewPortHeight / this.RC.currentRH + 1;
        }
      }

      // 4. Ð ÐµÐ½Ð´ÐµÑÐ¸Ð¼ ÑÑÑÐ°Ð½Ð¸ÑÑ Ñ Ð·Ð°Ð´Ð°Ð½Ð½Ð¾Ð¹ Ð¿ÐµÑÐµÑÐ°Ð±Ð¾ÑÐºÐ¾Ð¹
      this.updatePage('keydown', true, overWork);

      // 5. Ð£ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ Ð½Ð° Ð¿ÑÐ¸Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÑ Ð¾Ð±ÑÐ°Ð±Ð¾ÑÐºÐ¸ ÐºÐ»Ð°Ð²Ð¸Ñ
      this._paging = true;
      setTimeout(() => {
        // 6. Ð¢ÐµÐ¿ÐµÑÑ Ð¼Ñ Ð¼Ð¾Ð¶ÐµÐ¼ ÑÐ¾ÑÐ½Ð¾ ÑÐ°ÑÑÑÐ¸ÑÐ°ÑÑ ÐµÐ¼ÐºÐ¾ÑÑÑ Ð¿ÑÐµÐ´ÑÐ´ÑÑÐµÐ¹ ÑÑÑÐ°Ð½Ð¸ÑÑ
        const newPageCapacity =
          this.RC.pageCapacity(ri, this.scroller.viewPortHeight, this.state.dataSource.resultRows.length);
        // 7. Handle key
        if (this.state.ui.processKey(newPageCapacity, e)) {
          e.stopPropagation();
        }
        // 8. Done
        this._paging = false;
      }, 50);

      return true;
    }
    // ÐÑÑÐ°Ð»ÑÐ½Ð¾Ðµ Ð½Ð°Ð¼Ð½Ð¾Ð³Ð¾ Ð¿ÑÐ¾ÑÐµ
    let pageCapacity = this.RC.pageCapacity(ri, this.scroller.viewPortHeight, this.state.dataSource.resultRows.length);
    return this.state.ui.processKey(pageCapacity, e);
  }

  public dataKeyDown(e: any) {
    if (this.processKey(e)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  public checkAll(fieldName: string) {
    this.state.check.setColumnCheck(this.state.columnCollection.columnByFieldName(fieldName), true);
  }

  public uncheckAll(fieldName: string) {
    this.state.check.setColumnCheck(this.state.columnCollection.columnByFieldName(fieldName), false);
  }

  /**
   * Continue selecting
   * @param  e Event parameters
   */
  private doSelect(e: any) {
    const rr = this.cellByXY(e.clientX, e.clientY);
    if (rr && rr.fieldName !== '') {
      this.state.ui.proceedToSelect(rr);
    }

    this.scroller.checkAutoScrollX(e.clientX);
    this.scroller.checkAutoScrollY(e.clientY);
  }

  /**
   * Selection of the grid
   * @return GridSelection instance with selected ranges list.
   */
  public get selection() {
    return this.state.selection;
  }

  /**
   * Returns data which contained in selected ranges
   * @return Array with the data
   */
  public get selectedData(): any[] {
    return this.state.getSelectedData(this.selection).result;
  }

  public get draggedRows(): any[] {

    if (this.uiAction && this.uiAction.target) {
      if (this.uiAction.renderTarget === null) {
        // ÐÐµÑÐ²ÑÐµ ÑÑÐ¸ Ð·Ð°Ð¿Ð¸ÑÐ¸ Ð² Ð¾Ð±ÑÐ°ÑÐ½Ð¾Ð¼ Ð¿Ð¾ÑÑÐ´ÐºÐµ
        this.uiAction.renderTarget = [];
        for (let i = 0; i < 3 && i < this.uiAction.target.length; i++) {
          this.uiAction.renderTarget.unshift(this.uiAction.target[i]);
        }
      }
      return this.uiAction.renderTarget;
    }
    return [];
  }

  public getDragTransform(i: number): string  {
    const l = this.draggedRows.length;
    const scale = Math.pow(0.97, l - i - 1);
    const dx = -40;
    const dy = -i * this.state.settings.rowHeight + (l - i - 1) * 7 - 40;
    const res = 'matrix(' + scale + ', 0, 0, 1, ' + dx + ', ' + dy + ')';
    return res;
  }

  public getDragWidth(): string {
    let res = 0;
    this.state.layoutDrag.columns.forEach(c => res += c.width);
    return res + this.state.settings.widthUnit;
  }

  private checkRowDrag(e: MouseEvent): boolean {

    if (!this.state.settings.rowDrag) {
      return false;
    }

    if (this.uiAction.action === UIActionType.ROW_DRAG) {
      // Ð£Ð¶Ðµ Ð²ÐºÐ»ÑÑÐµÐ½Ð¾
      return false;
    }

    const xx = e.clientX;
    const yy = e.clientY;
    if (Math.abs(xx - this.uiAction.x) > 9 || Math.abs(yy - this.uiAction.y) > 9) {
      this.startDragRows();
      return true;
    }
    return false;
  }

  private startDragRows() {
    this.uiAction.action = UIActionType.ROW_DRAG;
    this.state.dragDrop.setDragItem(this.uiAction);
    this.setDragPosition(this.uiAction);
    this.detectChanges();
    this.dragInProcess(true);
    this.dragItem.nativeElement.style.visibility = 'visible';
  }

  protected specifyDropPosition(pos: RowPosition, rLeft: number, e: MouseEvent): RowPosition {
    return pos;
  }

  protected dropInfo(e: MouseEvent): any {

    let r = RowLayout.rowPosByXY(this.rowLayouts(this.displayedRows), e.clientX, e.clientY, this.state.isTree);
    const rl: RowLayout = r.rl;

    if (!rl) {
      return null;
    }

    const centerRect = this.scroller.centerRect;
    const rd: RowDirective = <RowDirective>rl.rowComponent;
    const rr = rd.firstCellRect();

    r = this.specifyDropPosition(r, rr.left, e);

    const canDrop = this.state.canDrop(this.uiAction.target, rl.rowComponent.row, r.pos);

    let dropTarget = null;
    if (canDrop !== '') {
      dropTarget = rl.rowComponent.row;
      r.pos = canDrop;
    }

    let top = (r.pos !== 'before' ? rl.clientRect.bottom : rl.clientRect.top) - 1;
    let left = rr.left;
    let height = 2;
    let width = rl.clientRect.width - (left - centerRect.left);

    if (r.pos === 'last') {
      left -= this.state.settings.levelIndent;
      width += this.state.settings.levelIndent;
    }

    if (r.pos === 'in') {
      top -= rl.clientRect.height - 3;
      height = rl.clientRect.height - 6;
    }

    if (left < centerRect.left) {
      left = centerRect.left;
    }

    if ((left + width) > rl.clientRect.right) {
      width = rl.clientRect.right - left;
    }

    const rect = new DOMRect(left, top, width, height);

    if (rect.top < centerRect.top - 1 || rect.top >= centerRect.bottom) {
      return null;
    }

    return {
      dropTarget: dropTarget,
      rowPosition: r,
      pos: r.pos,
      markerRect: rect
    };
  }

  protected dragRows(e: MouseEvent): RowPosition {

    if (!this.uiAction.move(e.clientX, e.clientY)) {
      //return null;
    }

    this.setDragPosition(this.uiAction);

    const di = this.dropInfo(e);

    if (di === null || di.dropTarget === null) {
      this.toggleClass(true, 'true-drag-not-allowed');
      this.toggleClass(false, 'true-drag-allowed');
      this.hideMarker();
    } else {
      this.showMarker(di.markerRect.left, di.markerRect.top, di.markerRect.width, di.markerRect.height, true);
      this.toggleClass(false, 'true-drag-not-allowed');
      this.toggleClass(true, 'true-drag-allowed');
    }

    this.scroller.checkAutoScrollY(e.clientY);

    return di ? di.rowPosition : null;
  }

  private endDragRows(e: MouseEvent) {

    this.hideMarker();
    this.scroller.stopAutoScroll();
    this.toggleClass(false, 'true-drag-not-allowed');
    this.toggleClass(false, 'true-drag-allowed');
    this.dragItem.nativeElement.style.visibility = 'hidden';
    this.dragInProcess(false);

    const di = this.dropInfo(e);
    if (di && di.dropTarget) {
      const ce = new RowDragEvent(this.uiAction.target, di.dropTarget, di.pos);
      this.rowDrag.emit(ce);
      if (!ce.isCanceled) {
        this.state.moveRows(this.uiAction.target, di.dropTarget, di.pos);
        this.rowDragged.emit(ce);
      }
    }
  }

  protected documentMouseMove(e: MouseEvent) {

    super.documentMouseMove(e);

    if (this.uiAction) // ÐµÑÐ»Ð¸ ÑÑÐ¾-ÑÐ¾ Ð½Ð°ÑÐ°Ð»Ð¾ÑÑ..
    {
      if (e.clientX === this.uiAction.x && e.clientY === this.uiAction.y) {
        return;
      }

      if (this.checkRowDrag(e)) {
        return;
      }

      if (this.uiAction.action === UIActionType.ROW_DRAG) {
        this.dragRows(e);
      }

      // ÐÑÐ¾Ð´Ð¾Ð»Ð¶Ð°ÐµÐ¼ Ð²ÑÐ´ÐµÐ»ÐµÐ½Ð¸Ðµ Ð´Ð°Ð½Ð½ÑÑ
      if (this.uiAction.action === UIActionType.SELECT) {

        let dt = Date.now();
        let ms = dt - this._lastSel;
        let delay = this.state.IE ? 70 : 0;

        if (ms < delay) {
          // ÐÐµ ÑÐ°Ðº Ð´Ð°Ð²Ð½Ð¾ Ð¾Ð±Ð½Ð¾Ð²Ð»ÑÐ»Ð¸..
          return;
        }

        this._lastSel = Date.now();
        this.doSelect(e);
        e.preventDefault();
        e.stopPropagation();
      }
    }
  }

  // ÐÐ°Ð²ÐµÑÑÐµÐ½Ð¸Ðµ Ð²ÑÐ´ÐµÐ»ÐµÐ½Ð¸Ñ Ð¾Ð±Ð»Ð°ÑÑÐ¸
  documentMouseUp(e: MouseEvent) {

    if (this.uiAction.action === UIActionType.ROW_DRAG) {
      // ÐÐµÑÐµÑÑÐ°Ð²Ð»ÑÐµÐ¼.
      this.endDragRows(e);
    }

    if (this.uiAction.action === UIActionType.SELECT) {
      let rr = this.cellByXY(e.clientX, e.clientY);
      if (rr && rr.fieldName !== '') {
        this.state.ui.endSelect(rr, false, e.button);
        this.focus();
      }
    }

    super.documentMouseUp(e);

    this.rowMouseUp.emit(e);

    // ÐÑÑÐ°Ð½Ð°Ð²Ð»Ð¸Ð²Ð°ÐµÐ¼ Ð°Ð²ÑÐ¾Ð¿ÑÐ¾ÐºÑÑÑÐºÑ
    this.scroller.stopAutoScroll();
    this.uiAction = null;
  }

  public resizeInProcess(value: boolean) {
    this.toggleClass(value, 'true-resize-in-process');
  }

  public dragInProcess(value: boolean) {
    this.toggleClass(value, 'true-drag-in-process');
  }

  private showMarker(mrX: number, mrY: number, mrW: number, mrH: number, rowDrag: boolean = false) {

    this.dropMarker.nativeElement.style.top = mrY + 'px';
    this.dropMarker.nativeElement.style.left = mrX + 'px';

    this.dropMarker.nativeElement.style.width = mrW + 'px';
    this.dropMarker.nativeElement.style.height = mrH + 'px';

    this.dropMarker.nativeElement.style.visibility = 'visible';
  }

  // Hide marker of REORDERING/RESIZING
  public hideMarker() {
    this.dropMarker.nativeElement.style.visibility = 'hidden';
  }

  proceedToResizeColumn(ui: UIAction) {

    let r0 = this.scroller.clientRect;

    let mrX = ui.x;

    if ((mrX > r0.left) && mrX < r0.right) {
      this.showMarker(mrX, r0.top + 1, 1, r0.height - 2);
    } else {
      this.hideMarker();
    }

    if (ui.x < r0.left) { // Ð»Ð¸ÑÑÐ°ÐµÐ¼ Ð²Ð»ÐµÐ²Ð¾
      this.scroller.scrollSpeedX = -this.state.st.autoScrollStep;
    } else {
      if (ui.x > r0.right) {
        this.scroller.scrollSpeedX = this.state.st.autoScrollStep;
      } else {
        this.scroller.scrollSpeedX = 0;
      }
    }
  }

  public resizeColumn(e: any) {
    if (e.action === 'start') {
      this.resizeInProcess(true);
      return;
    }
    if (e.action === 'end') {
      this.hideMarker();
      this.resizeInProcess(false);
      return;
    }
    this.proceedToResizeColumn(e.ui);
  }

  private setDragPosition(e: UIAction) {
    const dy = this.state.iOS ? window.pageYOffset : 0;
    this.dragItem.nativeElement.style.left = e.x + e.targetOffsetX + 'px';
    this.dragItem.nativeElement.style.top = dy + e.y + e.targetOffsetY + 'px';
  }

  public isDragColumn() {
    return this._dragColumn;
  }

  private startDragColumn(e: UIAction) {

    if (this.filterPopup && this.filterPopup.visible) {
      this.filterPopup.closePopup();
    }

    this._dragColumn = true;
    this.scroller.prepareAutoScroll();
    this.state.dragDrop.setDragItem(e);

    this.detectChanges('dragColumn');
    this.setDragPosition(e);

    this.dragItem.nativeElement.style.visibility = 'visible';

    this.dragInProcess(true);
  }

  protected commitDrag() {
    this.checkSize();
    this.need_recalc_page = true;
  }

  protected dragColumn(e: UIAction) {
    if (!this._dragColumn) {
      this.startDragColumn(e)
      return;
    }

    this.setDragPosition(e);

    if (Math.abs(e.x - this._drag_x0) < 5 && Math.abs(e.y - this._drag_y0) < 5) {
      return;
    }

    this._drag_x0 = e.x;
    this._drag_y0 = e.y;

    let dropInfo: any = null;
    this.headerParts.forEach(p => {
      if (p && !dropInfo) {
        dropInfo = p.canDrop(e, false); //showMarker);
      }
    });

    if (dropInfo) {
      if (e.target instanceof ColumnBand) {
        this.state.reorderBand(e.target, dropInfo);
      } else {
        this.state.reorderColumn(e.target, dropInfo, false);
      }
      this.commitDrag();
    }

    let r0 = this.scroller.checkAutoScrollX(e.x);
    // ÐÐµÑÐµÐ´Ð°ÐµÐ¼ rectangle
    this.checkParts(e.x, r0, e.target);
  }

  protected dropColumn(e: any) {
    this._dragColumn = false;

    this.scroller.stopAutoScroll();
    this.dragItem.nativeElement.style.visibility = 'hidden';

    let dropInfo: any = null;
    this.headerParts.forEach(p => {
      if (!dropInfo && p) {
        dropInfo = p.canDrop(e, false);
      }
    });

    if (dropInfo) {
      this.state.reorderColumn(e.target, dropInfo);
    } else {
      this.state.fixDrag(e.target);  // ÐÑÐ»Ð¸ ÑÐ°ÑÐ¸Ð»Ð¸ Ð¸Ð· Ð¿Ð°Ð½ÐµÐ»Ð¸ Ð³ÑÑÐ¿Ð¿Ð¸ÑÐ¾Ð²ÐºÐ¸, ÑÐ¾!
    }

    this.state.dragDrop.clearDragItem();
    this.dragInProcess(false);

    // ÐÐ¾ÑÐµÐ¼Ñ ÑÐµÑÐµÐ· 100 Ð¼Ð¸Ð»Ð»Ð¸ÑÐµÐºÑÐ½Ð´? ÐÐ»Ñ ÑÐ¾Ð³Ð¾,ÑÑÐ¾Ð±Ñ Ð¿Ð»Ð°Ð²Ð½Ð¾ Ð·Ð°ÑÑÑÐ»Ð¾
    setTimeout(()=> {
      this.state.layoutsHandler.setLayoutsVisibility();
      this.updatePage('dropColumn', true);
      // ÐÐ¾Ð¶ÐµÑ Ð¿Ð¾Ð¼ÐµÐ½ÑÑÑÑÑ ÑÐ¸ÑÐ¸Ð½Ð° ÑÐµÐ½ÑÑÐ°Ð»ÑÐ½Ð¾Ð¹ ÑÐ°ÑÑÐ¸
      this.checkSize();
    }, 100);
  }

  /**
   * ÐÐ±ÑÐ°Ð±Ð¾ÑÐºÐ° ÑÐ¾Ð±ÑÑÐ¸Ñ ÑÑÑÐ¾ÐºÐ¸ - Ð¿ÐµÑÐµÐºÐ»ÑÑÐµÐ½Ð¸Ðµ ÑÐµÐºÐ±Ð¾ÐºÑÐ°.
   * @param  e ÐÐ°ÑÐ°Ð¼ÐµÑÑÑ ÑÐ¾Ð±ÑÑÐ¸Ñ
   */
  public toggleCheckbox(e: any) {
    this.state.ui.toggleCheck(e.row, e.fieldName, e.value);
  }

  public toggleCheckColumn(col: Column) {
    this.state.ui.toggleCheckColumn(col);
  }

  public setAppearance() {
    super.setAppearance();
    this.dragItem.nativeElement.classList.add(this.state.sta.dragItemClass);
  }

  constructor(
    @Inject('gridState') public state: GridStateService,
    protected intl: InternationalizationService,
    protected elementRef: ElementRef,
    protected changeDetector: ChangeDetectorRef,
    protected keyValueDiffers: KeyValueDiffers) {

      super(state, intl, elementRef, changeDetector, keyValueDiffers);

      // Ð¡ÑÑÐ¾ÑÐºÐ° ÑÑÐ»Ð° Ð¿Ð¾ÑÐ»Ðµ ÑÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ...
      this.state.events.onRowUnfiltered.pipe(takeUntil(this.destroy$)).subscribe(r => {
        setTimeout(() => {
          if (this.state.dataSource.removeResultRow(r)) {
            this.state.layoutsHandler.updateSelectionIndices();
            this.need_recalc_page = true;
            this.updatePage('rowUnfiltered');
          }
        }, 100);
      });

      // ÐÐ·Ð¼ÐµÐ½ÐµÐ½Ñ ÐºÐ¾Ð»Ð¾Ð½ÐºÐ¸
      this.state.events.onColumnsChanged.pipe(takeUntil(this.destroy$)).subscribe(v => {        
        this.RC.clear();
        this.checkSize(true);
      });

      // ÐÐµÑÐµÑÐ°ÑÐºÐ¸Ð²Ð°Ð½Ð¸Ðµ Ð·Ð°Ð³Ð¾Ð»Ð¾Ð²ÐºÐ° ÐºÐ¾Ð»Ð¾Ð½ÐºÐ¸
      this.state.events.onDrag.pipe(takeUntil(this.destroy$)).subscribe(v => this.dragColumn(v));

      // Drop Ð·Ð°Ð³Ð¾Ð»Ð¾Ð²ÐºÐ° ÐºÐ¾Ð»Ð¾Ð½ÐºÐ¸
      this.state.events.onDrop.pipe(takeUntil(this.destroy$)).subscribe(v => this.dropColumn(v));

      // ÐÐ·Ð¼ÐµÐ½ÐµÐ½Ð¸Ðµ Ð²ÑÐ´ÐµÐ»ÐµÐ½Ð¸Ñ
      this.state.events.onSelect.pipe(takeUntil(this.destroy$)).subscribe(cellPos => {
        this.refreshSelection(cellPos);
        this.selectionChanged.emit(this.state.selection);
      });

      // ÐÐ·Ð¼ÐµÐ½ÐµÐ½Ð¸Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ
      this.state.events.onValueChanged.pipe(takeUntil(this.destroy$)).subscribe(v => this.detectChanges('valueChanged'));

      // ÐÐ·Ð¼ÐµÐ½ÐµÐ½Ð¸Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ ÑÐµÐºÐ±Ð¾ÐºÑÐ°
      this.state.events.onCheckedChanged.pipe(takeUntil(this.destroy$)).subscribe(e => this.checkedChanged.emit(e));

      // ÐÐºÐ»ÑÑÐµÐ½Ð¸Ðµ ÑÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ
      this.state.events.onStartEditing.pipe(takeUntil(this.destroy$)).subscribe(v => this.detectChanges('startEditing'));

      // ÐÑÐºÐ»ÑÑÐµÐ½Ð¸Ðµ ÑÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ
      this.state.events.onStopEditing.pipe(takeUntil(this.destroy$)).subscribe(returnFocus => {
        this.detectChanges();
        if (returnFocus && this.state.settings.autoFocusAfterEditor) {
          this.focus();
        }
      });
  }
}
